import type { PaginatedResponse, PaginationInfo } from '@types';

export function totalResults<T1, T2>(response: PaginatedResponse<T1, T2>): number {
    return response.pagination.totalCount;
}

export const isFirstPage = (pagination: PaginationInfo): boolean => pagination.pageNumber === 1;

export const isLastPage = (pagination: PaginationInfo): boolean => pagination.pageNumber === pagination.totalPages;

// hide pagination if total rows are less than 10
// use this rule for all tables
export const hidePagination = (total: number): boolean => {
    return total <= 10;
};
